import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function FocusAreas() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center" data-id="element-38">
      <div className="w-full max-w-6xl" data-id="element-39">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 sm:gap-16 md:gap-8 relative" data-id="element-40">
          {/* Desktop Dividers */}
          <div className="hidden md:block absolute top-0 bottom-0 left-1/3 w-px bg-brand-gold/20 -translate-x-1/2" data-id="element-41" />
          <div className="hidden md:block absolute top-0 bottom-0 left-2/3 w-px bg-brand-gold/20 -translate-x-1/2" data-id="element-42" />

          {/* Mobile Dividers */}

          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-43">
            <h3 className="font-heading text-sm sm:text-base tracking-widest uppercase text-brand-gold mb-4 sm:mb-8" data-id="element-44">
              Media
            </h3>
            <p className="font-heading text-lg sm:text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-45">
              Backing projects that shape culture
            </p>
          </motion.div>

          <div className="block md:hidden w-12 h-px bg-brand-gold/20 mx-auto" data-id="element-46" />

          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-47">
            <h3 className="font-heading text-sm sm:text-base tracking-widest uppercase text-brand-gold mb-4 sm:mb-8" data-id="element-48">
              Technology
            </h3>
            <p className="font-heading text-lg sm:text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-49">
              Early-stage and emerging infrastructure
            </p>
          </motion.div>

          <div className="block md:hidden w-12 h-px bg-brand-gold/20 mx-auto" data-id="element-50" />

          <motion.div variants={itemVariants} className="flex flex-col items-center text-center px-4 md:px-12" data-id="element-51">
            <h3 className="font-heading text-sm sm:text-base tracking-widest uppercase text-brand-gold mb-4 sm:mb-8" data-id="element-52">
              Opportunistic Investments
            </h3>
            <p className="font-heading text-lg sm:text-xl md:text-2xl text-brand-warmGrey font-light leading-snug tracking-wide" data-id="element-53">
              High-conviction, asymmetric opportunities
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}